<template>
  <div class="page-container" ref="chatPage">
    <!-- 右侧聊天区域 -->
    <div class="chat-container">
      <!-- 消息列表 -->
      <div class="messages" ref="messagesContainer" :style="{ paddingBottom: isResponding ? '60px' : '20px' }">
        <div class="messages_title">{{ userInfo?.company }}<span v-if="accessType == 'tz'">碳知</span><span
            v-else-if="accessType == 'tpc'">碳盘查</span><span v-else-if="accessType == 'tzj'">碳足迹</span>项目</div>
        <div v-for="(message, index) in messages" :key="index" class="message-wrapper"
          :class="{ 'user-message': message.isUser }">
          <!-- AI消息：左侧头像 + 消息 -->
          <template v-if="!message.isUser">
            <div style="width: 100%;">

              <!-- 深度思考样式 -->
              <!-- <div v-if="message.hasDeepThinking && !message.isWelcome" class="deep-thinking-container"
                :class="{ 'expanded': message.expanded }">
                <div class="thinking-summary" @click="toggleThinking(index)">
                  <div style="display: flex; align-items: center;">
                    <img style="width: 12px; height: 12px; margin-right: 3px;" src="../assets/images/think.png" alt="">
                    <span class="summary-text">{{ message.expanded ? '点击收起' : '深度思考已完成' }}</span>
                  </div>
                  <div class="arrow-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#555"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M6 9l6 6 6-6"></path>
                    </svg>
                  </div>
                </div>

                <div class="thinking-content" v-if="message.expanded">
                  <div class="thinking-step completed">
                    <div class="step-header">
                      <span class="step-number">1</span>
                      <span class="step-title">问题定义</span>
                      <span class="step-status">已完成</span>
                    </div>
                    <div class="step-description">
                      明确碳盘查项目的已知条件和目标：工厂类型为制造业，需计算年度直接与间接碳排放。
                    </div>
                  </div>

                  <div class="thinking-step completed">
                    <div class="step-header">
                      <span class="step-number">2</span>
                      <span class="step-title">分析框架</span>
                      <span class="step-status">已完成</span>
                    </div>
                    <div class="step-description">
                      采用 IPCC 碳排放核算指南，总排放 = 直接排放 + 间接排放。
                    </div>
                    <div class="step-code">
                      <pre>总排放 = Σ(活动数据 × 排放因子)</pre>
                    </div>
                  </div>

                  <div class="thinking-step active">
                    <div class="step-header">
                      <span class="step-number">3</span>
                      <span class="step-title">数据收集</span>
                      <span class="step-status">进行中</span>
                    </div>
                    <div class="step-description">
                      收集能源消耗数据：天然气 10,000 m³，电力 500,000 kWh；查询最新排放因子...
                    </div>
                  </div>

                  <div class="final-answer">
                    <div class="answer-header">深度思考结论</div>
                    <div class="answer-content">
                      该工厂年度碳排放总量为 <strong>268 吨 CO₂</strong>，其中直接排放 18 吨，间接排放 250 吨。
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="message-bubble" @mouseenter.stop="debouncedShowTime(index)"
                @mouseleave.stop="debouncedShowTime(null)">
                <div class="message-content" ref="messageContent">
                  <template v-if="message.isLoading">
                    <div class="thinking-message">
                      <div class="thinking-icon">
                        <i class="el-icon-loading"></i>
                      </div>
                      <!-- 正在进行数据采集<span class="thinking-dots"></span> -->
                    </div>
                    <div class="loading-message" v-html="message.displayText"></div>
                  </template>
                  <template v-else>
                    <div v-html="message.displayText || message.content"></div>
                  </template>
                </div>
                <div class="bottom_contral" v-if="message.responseTime && showTimeIndex === index && !isResponding"
                  :data-messageId="message.message_id">

                  <div class="contralView" v-if="accessType == 'tz'">
                    <div class="contralView_item">
                      <div class="contralView_icon copy-icon" @click="copyText(message.displayText || message.content)">
                      </div>
                    </div>
                    <div class="contralView_item">
                      <div class="contralView_icon contralView_icon2 like-icon"
                        :class="{ 'liked': message.rating === 'like' }" @click="handleReaction(message, index, 'like')">
                      </div>
                    </div>
                    <div class="contralView_item">
                      <div class="contralView_icon contralView_icon3 dislike-icon"
                        :class="{ 'disliked': message.rating === 'dislike' }"
                        @click="handleReaction(message, index, 'dislike')"></div>
                    </div>
                  </div>
                  <div class="timeView">{{ message.responseTime }}</div>
                </div>
                <div class="bottom_contral" v-else></div>
                <el-dialog :title="$t('chatPage.feedbackTitle')" :visible.sync="feedBackVisible"
                  :modal-append-to-body="false" :close-on-click-modal="false" custom-class="custom-dialog"
                  :before-close="() => (feedBackVisible = false)" @close="message.feedback = ''">
                  <div class="dialog-content">
                    <div class="dialog-text">
                      <div :class="{ 'active': selectedFeedBack === item }" class="dialog-text_view"
                        v-for="item in feedBackList" :key="item" @click="selectFeedBack(item)">
                        {{ item }}
                      </div>
                    </div>
                    <el-input v-model="message.feedback" :placeholder="$t('chatPage.feedbackPlaceholder')"
                      maxlength="20" class="custom-input" show-word-limit />
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="feedBackVisible = false" class="custom-cancel-btn">
                      {{ $t('chatListI18n.cancel') }}
                    </el-button>
                    <el-button type="primary" @click="handleFeedback(message, index)" class="custom-confirm-btn">
                      {{ $t('chatListI18n.confirm') }}
                    </el-button>
                  </span>
                </el-dialog>
              </div>
              <div class="tj_list"
                v-if="suggestList.length > 0 && accessType == 'tz' && index === messages.length - 1 && index !== 0">
                <div class="tj_list_content" @click="handleClick(item)" v-for="(item, index) in suggestList"
                  :key="index">
                  {{ item }}
                </div>
              </div>
            </div>
          </template>
          <!-- 用户消息：消息 + 右侧头像 -->
          <template v-else>
            <div class="message-bubble">
              <div class="message-content">
                <div class="upload-info messageView" v-if="message.files?.length > 0">
                  <div class="upload-item_file" v-for="(file, index) in message.files" :key="index">
                    <div class="upload-preview" v-if="file.type && file.type.startsWith('image')">
                      <img :src="file.url" alt="uploaded-image" @click="previewImage(file.url)"
                        style="cursor: pointer;" />
                    </div>
                    <div class="upload-details down" v-else>
                      <el-tooltip placement="bottom" effect="light">
                        <div slot="content">{{ file.name }}</div>
                        <div class="upload-name">{{ file.name }}</div>
                      </el-tooltip>
                      <div class="downView">
                        <i class="el-icon-download" @click="downLoad(file)"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-html="message.content"></div>
              </div>
            </div>

          </template>
        </div>
      </div>

      <!-- 解析 -->
      <div v-if="accessType !== 'tz' && showLog" class="analysis_whole" :class="{ 'analysis-expanded': showAnalysis }">
        <!-- Header: 点击切换 -->
        <div class="analysis_header" @click="toggleAnalysis">
          <div class="analysis_left">
            <img class="analysis_left_img" :src="!showAnalysisImg ? require('@/assets/images/analysis.png') : require('@/assets/images/analysis.gif')" alt="" />
            <div class="analysis_title">
              <div class="title-scroller">
                <transition name="slide-up" mode="out-in">
                  <div :key="currentIndex" class="title-item">
                    {{ latestMessage }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="analysis_right">
            <img
              class="analysis_right_img"
              :src="showAnalysis ? require('@/assets/images/harvest.png') : require('@/assets/images/harvest_hover.png')"
              alt=""
            />
          </div>
        </div>

        <!-- 展开内容区：显示最近 5 条，最新在底部 -->
        <div v-show="showAnalysis" class="analysis_content" ref="analysisContent">
          <div
            class="item"
            v-for="(msg, index) in displayedItems"
            :key="index"
          >
            <span class="text">{{ msg }}</span>
          </div>
        </div>
      </div>

      <!-- 输入区域 -->
      <div class="input-area">
        <div class="input-container">
          <!-- 上传文件预览区域 -->
          <div class="upload-info" v-if="uploadingFiles.length > 0">
            <!-- 正在上传的文件 -->
            <div class="upload-item_file other_view" v-for="file in uploadingFiles" :key="file.name">
              <div class="upload-progress">
                <div class="progress-info">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="progress-percent">{{ uploadProgress[file.name] || 0 }}%</span>
                </div>
                <el-progress :percentage="uploadProgress[file.name] || 0" :stroke-width="6" :show-text="false"
                  color="#409EFF" class="progress-bar">
                </el-progress>
              </div>
            </div>
          </div>
          <!-- 已上传完成的文件 -->
          <div class="upload-info" v-if="requestData.files.length > 0">
            <div class="upload-item_file" v-for="(file, index) in requestData.files" :key="index">
              <div class="upload-preview" v-if="file.type && file.type.startsWith('image')">
                <img :src="file.url" />
              </div>
              <div class="upload-details" v-else>
                <el-tooltip placement="bottom" effect="light">
                  <div slot="content">{{ file.name }}</div>
                  <div class="upload-name">{{ file.name }}</div>
                </el-tooltip>
                <div class="upload-size">{{ file.size }}</div>
              </div>
              <i class="el-icon-circle-close upload-remove" @click="removeFile(index)"></i>
            </div>
          </div>
          <el-input type="textarea" v-model="newMessage" ref="messageInput" @keydown.native="handleKeyDown"
            @keyup.native="handleKeyUp" :placeholder="isReadonly ? '当前会话为只读状态，点击左侧开启新项目' : $t('wecome.placeholder')"
            :disabled="isReadonly">
          </el-input>
          <div class="send-container">
            <div class="file-container">
              <el-tooltip :content="`${$t('chatPage.uploadFileTips')} ${fileAccept}, ${imageAccept}`" placement="top"
                v-if="!isReadonly" popper-class="file-tooltip">
                <div class="file-item mglr" @click="handleUnifiedUpload">
                  <img src="../assets/images/file_icon_2.png" />
                </div>
              </el-tooltip>
              <!-- <el-tooltip :content="`${$t('chatPage.imageTipsFront')}${imageAccept} ${$t('chatPage.imageTipsBack')}`"
                placement="top" v-if="!isReadonly">
                <div class="file-item mglr" @click="handleAddImage">
                  <img src="../assets/images/file_icon_1.png" />
                </div>
              </el-tooltip> -->
            </div>
            <div class="sLine"></div>
            <button v-if="!isResponding && !uploading && !isReadonly" class="chat_content_send" @click="sendMessage">
              <img class="chat_content_send_icon" src="../assets/images/send.png" alt="send" />
            </button>
            <button v-else-if="uploading || isReadonly" class="chat_content_send disabledBtn" disabled>
              <img class="chat_content_send_icon" src="../assets/images/send.png" alt="send" />
            </button>
            <el-tooltip v-else class="item" effect="dark" :content="$t('chatPage.stopGenerate')" placement="top-start">
              <button class="chat_content_send" @click="stopResponse">
                <div class="stopView"></div>
              </button>
            </el-tooltip>
          </div>
          <!-- 深度思考按钮 -->
          <!-- <div v-if="accessType !== 'tz'" class="deepKing" :class="{ deepActive }" @click="deepActive = !deepActive">
            <img class="deepKing-img" src="../assets/images/think.png" alt="">
            <span class="deepKing-text">深度思考</span>
          </div> -->
        </div>
        <!-- 下滑按钮 -->
        <div v-show="showScrollToBottom" class="scroll-btn scroll-to-bottom-btn" @click="btnClickScrollToBottom">
          <img src="../assets/images/scrolltobottom1.png" alt="bottom" />
        </div>
      </div>

      <div class="baseInfo">
        <div>{{ $t('footer.tz') }}</div>
        <div>{{ $t('footer.vd') }} {{ version }}</div>
      </div>
      <!-- 右侧预览区域 -->
      <!-- 暂时隐藏：reqBool prop 和事件监听器在 ChatPreview.vue 中未定义 -->
      <ChatPreview 
        v-if="showChatPreview" 
        :conversationId="conversationId" 
        ref="chatPreview"
        @new-logs="handleNewLogs"
      />
      <!-- @update:reStart="updateReStart" @update:showPreview="updateShowPreview" -->
      <excel-viewer ref="excelViewer" @success="saveAndSendFile" />
    </div>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";
import katex from "katex";
import mkatex from "markdown-it-katex";
import "katex/dist/katex.min.css";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import * as echarts from "echarts";
import markdownItEcharts from "markdown-it-echarts";
import debounce from "lodash/debounce";
import config from "@/utils/config";
import ExcelViewer from '@/components/ExcelViewer.vue'

import {
  uploadFile,
  messagesInfo,
  guestLogin,
  stopChat,
  suggestedList,
  sendFeedbackApi,
} from "@/api";
import { mapState, mapMutations } from "vuex";
import request from "@/utils/request";
import { handleLogout } from "@/utils/request";
import ChatPreview from "@/components/ChatPreview.vue";
import version from "@/utils/version";

// 配置 markdown-it
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return `<div class="code-block">
                  <pre class="hljs"><code class="language-${lang}">${hljs.highlight(str, { language: lang, ignoreIllegals: true }).value
          }</code></pre>
                </div>`;
      } catch (__) {
        // 忽略错误，使用默认渲染
      }
    }
    return `<pre class="hljs"><code>${md.utils.escapeHtml(str)}</code></pre>`;
  },
});

md.use(markdownItEcharts, { echarts });
md.use(mkatex);

export default {
  components: {
    ChatPreview,
    ExcelViewer
  },
  name: "ChatPage",
  provide() {
    return {
      getExcelViewer: () => this.$refs.excelViewer
    };
  },
  computed: {
    ...mapState(['referer', "userInfo", "showLogin", "accessType", "sidebarExpanded", "previewExpanded", "tempReadonly"]),
    // 判断是否通过iframe嵌入
    isIframeEmbedded() {
      return this.referer && this.referer.trim() !== '';
    },
    // 获取配置
    config() {
      return config;
    },
    // 日志的展示计算
     latestMessage() {
      if (this.analyItems.length === 0) {
        if (this.accessType == 'tpc') {
          return '欢迎使用碳盘查Agent服务！'
        } else if (this.accessType == 'tzj') {
          return '欢迎使用碳足迹Agent服务！'
        }
      }
      // 确保不越界
      const index = Math.min(this.currentIndex, this.analyItems.length - 1);
      return this.analyItems[index];
    },

    // 最近5条（用于日志展开内容区，按时间顺序：最早 → 最新）
    displayedItems() {
      return this.analyItems.slice(0, this.currentIndex + 1);
    },
  },
  data() {
    return {
      messages: [],
      newMessage: "",
      isResponding: false,
      chatHistory: [],
      currentChatIndex: 0,
      typingSpeed: 50, // 打字速度（毫秒/字符）
      avatarConfig: {
        tz: {
          type: "color",
          color: "#1a73e8",
        },
        user: {
          type: "color",
          color: "#34a853",
        },
      },
      typeName: '',
      lastUserMessage: "", // 添加这个来保存用户最后发送的消息
      responseMap: {}, // 初始化 responseMap
      username: localStorage.getItem("username") || "未登录",
      loginTime: localStorage.getItem("loginTime") || "",
      eventSource: null, // 新增 EventSource 实例变量
      fullResponse: "", // 用于存储完整的回复内容
      controller: null, // 用于控制响应的 AbortController
      conversationId: "",
      message_id: "",
      suggestList: [],
      task_id: "",
      reqBool: false, // 用于控制侧栏响应耗时的开始与结束
      showChatPreview: true, // 流程区域的显示与隐藏
      showPreview: true, // 是否显示预览区域
      requestData: {
        inputs: {
          language: this.$i18n.locale,
        },
        query: "",
        response_mode: "streaming",
        conversation_id: "",
        user: "",
        files: [], // 存储上传的文件信息
        responseTime: "",
        message_id: "",
        feedback: "",
        rating: null,
      },
      reStart: true, // 重新开始
      isHistory: false,
      showTimeIndex: null, // 当前显示时间的消息索引
      debouncedShowTime: null, // 用于存储防抖函数
      version,
      fileAccept: ".xls,.xlsx,.txt,.doc,.docx,.pdf,.zip,.rar,.7z,.tar",
      imageAccept: ".png,.jpg,.jpeg",
      isAtBottom: true, // 是否在底部
      isScrollingToTop: false, // 是否正在滚动到顶部
      showScrollToBottom: false, // 是否显示下滑按钮
      isScrollingToBottom: false, // 是否正在滚动到底部
      feedBackVisible: false, // 反馈弹窗是否显示
      selectedFeedBack: "", // 选中的反馈
      feedBackList: this.$t("chatPage.feedBackList"), // 反馈列表
      expanded: false,
      windowResizeHandler: null, // 窗口大小变化处理器
      viewportObserver: null, // 视口观察器
      debouncedHandleLayoutChange: null, // 防抖的布局变化处理函数
      deepActive: false,
      uploading: false, // 新增：文件上传状态
      uploadingFiles: [], // 新增：正在上传的文件列表
      uploadProgress: {}, // 新增：上传进度
      isReadonly: null,
      showAnalysis: false, // 解析的收起展开
      currentIndex: 0, // 初始展示的index
      analyItems: [], // 接收展示的数组
      scrollTimer: null,
      showLog: true,
      showAnalysisImg: false
    };
  },
  methods: {
    ...mapMutations(["setToken", "setShowLogin", "setUserInfo", "setReadonly"]),

    // 关闭登录框
    handleLoginClose() {
      this.setShowLogin(false); // 关闭登录框
    },

    // 新增：处理页面可见性变化
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        // 页面重新可见时，重新计算布局
        this.$nextTick(() => {
          this.handleLayoutChange();
        });
      }
    },

    // 深度思考展开收起功能
    toggleThinking(index) {
      const message = this.messages[index];
      // 仅允许 hasDeepThinking 的消息 toggle
      if (!message || !message.hasDeepThinking) return;

      // 初始化 expanded（其实通常已有，但保险起见）
      if (message.expanded == null) {
        this.$set(message, 'expanded', false);
      }

      // 切换
      this.$set(message, 'expanded', !message.expanded);
    },
    // 处理键盘弹起事件
    handleKeyUp(event) {
      if (this.isResponding) return; // 如果正在响应，则不处理键盘事件
      if ((event.shiftKey || event.ctrlKey) && event.key === "Enter") {
        // Shift+Enter 或 Ctrl+Enter 换行
        return;
      }
      if (event.key === "Enter") {
        this.sendMessage(); // 单独按 Enter
      }
    },
    // 处理键盘按下事件
    handleKeyDown(event) {
      // Shift+Enter 或 Ctrl+Enter 允许换行，不阻止默认行为
      if ((event.shiftKey || event.ctrlKey) && event.key === 'Enter') {
        if (event.ctrlKey) {
          // 手动处理 Ctrl+Enter 换行
          event.preventDefault();
          const textarea = this.$refs.messageInput.$refs.textarea;
          if (textarea) {
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            this.newMessage = this.newMessage.substring(0, start) + '\n' + this.newMessage.substring(end);
            this.$nextTick(() => {
              textarea.selectionStart = textarea.selectionEnd = start + 1;
              textarea.focus();
            });
          }
        }
        // 对于 Shift+Enter，允许默认行为
        return;
      }
      // 如果按下Enter但没有按Shift也没有按Ctrl，阻止默认换行行为
      if (event.key === 'Enter' && !event.shiftKey && !event.ctrlKey) {
        event.preventDefault();
      }
    },
    // 发送消息
    sendMessage(keepTrailingLineBreaks = true) {
      if (!this.newMessage.trim() || this.isResponding) {
        this.$message.error(this.$t("chatPage.chatMessage"));
        return;
      }
      this.analyItems = [] // 清空日志列表
      this.showAnalysis = false // 关闭展开 
      this.reqBool = true; // 开始响应耗时计时
      const message = keepTrailingLineBreaks
        ? this.newMessage
        : this.newMessage.replace(/\n+$/, ""); // 去除末尾的换行符，保留中间的换行符
      const userMsg = {
        content: message,
        isUser: true,
        isTyping: false,
        files: this.requestData.files,
        rating: null,
        expanded: false, // ✅ 为每条消息单独记录展开状态
      };
      this.lastUserMessage = message;
      this.messages.push(userMsg);
      this.updateChatPreview(userMsg.content);
      this.newMessage = "";
      this.suggestList = [];
      this.isAtBottom = true;
      // this.scrollToBottom();
      this.forceScrollToBottom()
      this.getAIResponse();
      // startSideScreenSSE 的调用已移至 getAIResponse 的 onmessage 回调中，在第一次获取到 conversationId 时调用
      // 展开右边分屏
      // if (this.messages.length == 2 && this.accessType != 'tz' && this.$refs.chatPreview?.$data.switchBool == false) {
      // this.$refs.chatPreview?.switchDrawer(true); //暂时禁用
      // }
    },

    // 确保获取有效的 token
    async ensureToken() {
      let storeToken = this.$store.state.token;
      let storeUserInfo = this.$store.state.userInfo;
      if (!storeToken && !storeUserInfo) {
        try {
          const response = await guestLogin({
            url: this.referer
          });
          const { token, ...userInfo } = response.data.data;
          this.requestData.user = userInfo.user_id;
          storeToken = token;
          localStorage.setItem("token", token);
          this.setToken(token);
          this.setUserInfo(userInfo);
        } catch (error) {
          this.messages.pop(); // 删除加载效果消息
          this.messages.push({
            content: this.$t("chatPage.getResponseError"),
            isUser: false,
            isTyping: false,
            isLoading: false,
          });
          throw error;
        }
      }
      return storeToken;
    },

    // 获取AI回复
    async getAIResponse() {
      this.isResponding = true;
      this.fullResponse = "";
      this.requestData.query = this.lastUserMessage;
      this.requestData.conversation_id = this.conversationId;
      try {
        const token = await this.ensureToken();
        this.requestData.user = this.userInfo.user_id;
        let aiMsg = {
          content: "",
          displayText: "",
          isUser: false,
          isTyping: true,
          isLoading: true,
          responseTime: "",
          message_id: "",
          rating: null,
          expanded: false, // ✅ 为每条消息单独记录展开状态
          hasDeepThinking: this.deepActive,
        };
        if (this.messages.length > 0 && this.messages[this.messages.length - 1].isLoading) {
          this.messages.pop(); // 删除上一个消息
        }
        this.messages.push(aiMsg);
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const baseURL = request.defaults.baseURL;
        const url = `${baseURL}/pack/chatMessages`;
        const currentUrl = window.location.href;
        const separator = currentUrl.includes('?') ? '&' : '?';
        const urlId = this.getQueryParam(currentUrl, 'id');
        console.log("baseURL", baseURL, request.defaults);

        await fetchEventSource(url, {
          method: "POST",
          signal: signal,
          reconnect: false, // 不自动重连
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "accept-language": this.$i18n.locale
          },
          body: JSON.stringify(this.requestData),
          openWhenHidden: true,
          onmessage: (event) => {
            const data = JSON.parse(event.data);
            this.conversationId = data.conversation_id || this.conversationId;
            this.message_id = data.message_id;
            this.task_id = data.task_id || this.task_id;

            // 如果是碳盘查碳足迹场景，且首次获取到 conversationId，启动右边屏 SSE
            // 使用局部变量记录是否已启动，避免每次消息都重复启动
            if (this.conversationId && this.accessType != 'tz') {
              // 检查是否已经为当前 conversationId 启动了 SSE
              const chatPreview = this.$refs.chatPreview;
              if (chatPreview && chatPreview.sideScreenSSEConversationId !== this.conversationId) {
                this.$nextTick(() => {
                  chatPreview.startSideScreenSSE();
                });
              }
            }

            if (!urlId && urlId != this.conversationId) {
              const newUrl = `${currentUrl}${separator}id=${this.conversationId}`;
              if (window.location.href !== newUrl) {
                window.history.pushState({}, '', newUrl);
                const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                const isOnlyOneUserMessage = this.messages.filter(item => item.isUser).length === 1;
                if (isOnlyOneUserMessage && userInfo.phone) {
                  // ✅ 发出全局事件，通知 Sidebar 刷新历史记录
                  this.$root.$emit('refresh-chat-history', {
                    type: this.accessType,
                    conversationId: this.conversationId
                  });
                }
              }
            }
            if (data.event === "done") {
              // this.stopResponse();
              this.$nextTick(() => {
                const formattedResponse = this.formatMessage(this.fullResponse);
                aiMsg.displayText = formattedResponse;
                aiMsg.responseTime = this.getCurrentTime(data.created_at);
                aiMsg.message_id = data.message_id;
                aiMsg.isLoading = false;
                this.messages[this.messages.length - 1] = aiMsg;
              });
              return;
            } else if (data.event === "error") {
              const errorMessage = this.$t("chatPage.getResponseError");
              this.messages.pop(); // 删除加载效果消息
              this.messages.push({
                content: `${errorMessage}`,
                isUser: false,
                isTyping: false,
                isLoading: false,
              });
              console.log(this.messages)
              this.isResponding = false;
              this.reqBool = false; // 停止响应耗时计时
              // this.scrollToBottom();
              // this.forceScrollToBottom()
              this.smartScrollToBottom()
              // this.stopResponse();
              return;
            } else if (data.event === "message_end" && this.accessType == 'tz') {
              this.loadSuggestedList();
            } else if (data.event === "message_end"){
              this.showAnalysisImg = false
            }
            if (data.event.trim() === "" || data.event === "ping") return;
            if (data.answer) {
              this.fullResponse += data.answer;
              const formattedResponse = this.formatMessage(this.fullResponse);
              aiMsg.displayText = formattedResponse;
              // console.log(aiMsg.displayText,'aiMsg.displayText')
              aiMsg.isLoading = false;
              aiMsg.responseTime = this.getCurrentTime(data.created_at);
              aiMsg.message_id = data.message_id;
              this.messages[this.messages.length - 1] = aiMsg;
              // this.scrollToBottom();
              // this.forceScrollToBottom()
              this.smartScrollToBottom()
            }
            this.requestData.files = []; // 清空文件信息
          },
          onclose: () => {
            this.isResponding = false;
            this.$store.commit("setIsResponding", false);
            this.reqBool = false; // 停止响应耗时计时
            // console.log("chat onclose");
          },
          onerror: (error) => {
            // console.log("chat onerror", error);
            // if(error === "TypeError: network error"){
            //   this.stopResponse();
            // }
            // console.log("是不是正确", error === "TypeError: network error");
            this.messages.pop(); // 删除加载效果消息
            this.messages.push({
              content: this.$t("chatPage.getResponseError"),
              isUser: false,
              isTyping: false,
              isLoading: false,
            });
            this.isResponding = false;
            this.$store.commit("setIsResponding", false);
            this.reqBool = false; // 停止响应耗时计时

            // this.scrollToBottom();
            // this.forceScrollToBottom()
            this.smartScrollToBottom()

            console.log("打印出错日志", error);
            throw error; // 处理错误
            // this.stopResponse();
          },
          onopen: async (response) => {
            if (response.status == 401) {
              this.stopResponse();
              this.isResponding = false;
              this.reqBool = false; // 停止响应耗时计时
              handleLogout();
            }
          },
        })
      } catch (error) {
        console.log("chatPage fetchEventSource error……", error);
        console.log("是不是正确", error == "TypeError: network error");
        if (error == "TypeError: network error") {
          this.stopResponse();
        }
        this.messages.push({
          content: "",
          isUser: false,
          isTyping: false,
          isLoading: false,
        });
        this.isResponding = false;
        this.reqBool = false; // 停止响应耗时计时
      }
    },

    //截取url参数
    getQueryParam(url, param) {
      const regex = new RegExp(`[?&]${param}=([^&]+)`);
      const match = url.match(regex);
      return match ? decodeURIComponent(match[1]) : null;
    },

    // 处理普通消息的打字效果
    typeMessage(message) {
      let currentIndex = 0;
      const typeNextChar = () => {
        if (currentIndex < message.length) {
          this.messages[this.messages.length - 1].displayText = message.slice(
            0,
            currentIndex + 1
          );
          currentIndex++;
          // this.scrollToBottom();
          this.forceScrollToBottom()
          setTimeout(typeNextChar, this.typingSpeed);
        } else {
          this.messages[this.messages.length - 1].isTyping = false;
          this.messages[this.messages.length - 1].isLoading = false;
          this.isResponding = false;
          // this.scrollToBottom();
          this.forceScrollToBottom()
        }
      };
      setTimeout(typeNextChar, this.typingSpeed);
    },

    //下载附件
    downLoad(file) {
      const a = document.createElement('a');
      a.href = file.url;
      a.setAttribute('download', file.name);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.$message({
        message: this.$t("chatPage.downloadSuccess"),
        type: 'success'
      });
    },

    // 图片预览功能
    previewImage(imageUrl) {
      // 创建预览遮罩层
      const previewOverlay = document.createElement('div');
      previewOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        cursor: pointer;
      `;

      // 创建图片容器
      const imageContainer = document.createElement('div');
      imageContainer.style.cssText = `
        max-width: 90%;
        max-height: 90%;
        position: relative;
      `;

      // 创建预览图片
      const previewImg = document.createElement('img');
      previewImg.src = imageUrl;
      previewImg.style.cssText = `
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      `;

      // 创建关闭按钮
      const closeBtn = document.createElement('div');
      closeBtn.innerHTML = '×';
      closeBtn.style.cssText = `
        position: absolute;
        top: -40px;
        right: -40px;
        width: 30px;
        height: 30px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
        color: #333;
        transition: all 0.3s;
      `;

      // 点击关闭按钮或遮罩层关闭预览
      const closePreview = () => {
        document.body.removeChild(previewOverlay);
      };

      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closePreview();
      });

      previewOverlay.addEventListener('click', closePreview);

      // 组装元素
      imageContainer.appendChild(previewImg);
      imageContainer.appendChild(closeBtn);
      previewOverlay.appendChild(imageContainer);
      document.body.appendChild(previewOverlay);

      // 添加键盘事件支持ESC键关闭
      const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
          closePreview();
          document.removeEventListener('keydown', handleKeyDown);
        }
      };

      document.addEventListener('keydown', handleKeyDown);
    },

    //获取历史信息
    getHistoryMessages() {
      // logs 清空日志
      this.analyItems = [];
      this.showLog = false;
      
      if (this.accessType === "tz") {
        this.showChatPreview = false;
        this.handleLayoutChange();
      } else {
        this.showChatPreview = true;
      }
      // const baseURL = "https://ai.carbonneutrality-group.com:51443";
      messagesInfo({
        conversation_id: this.conversationId,
        user: this.userInfo.user_id,
        access_type: this.accessType,
        limit: 100
      })
        .then((response) => {
          if (response.data) {
            const history = response.data.data.data;
            this.messages = []; // 清空历史消息

            // 先添加前端配置的欢迎语
            let welcomeContent = "";
            switch (this.accessType) {
              case "tz":
                if (this.userInfo) {
                  welcomeContent = this.userInfo.user_name + ', ' + this.$t(config.chatContentConfig.aiContent);
                } else {
                  welcomeContent = this.$t(config.chatContentConfig.aiContent);
                }
                break;
              case "tpc":
                if (this.userInfo) {
                  welcomeContent = `<span style="color: #1a73e8; font-weight: 600;"> ${this.userInfo.user_name}, </span>&nbsp  ${this.$t(config.chatContentConfig.tpcContent)}`;
                } else {
                  welcomeContent = this.$t(config.chatContentConfig.tpcContent);
                }
                break;
              case "tzj":
                if (this.userInfo) {
                  welcomeContent = `<span style="color: #1a73e8; font-weight: 600;"> ${this.userInfo.user_name}, </span>&nbsp  ${this.$t(config.chatContentConfig.tzjContent)}`;
                } else {
                  welcomeContent = this.$t(config.chatContentConfig.tzjContent);
                }
                break;
              default:
                break;
            }

            if (welcomeContent) {
              this.messages.push({
                content: welcomeContent,
                isUser: false,
                isTyping: false,
                isWelcome: true
              });
            }

            // 再添加接口返回的历史消息
            history.forEach((item) => {
              if (item.query) {
                if (item.message_files?.length > 0) {
                  this.messages.push({
                    content: item.query,
                    isUser: true,
                    files: item.message_files.map(file => ({
                      name: file.filename,
                      type: file.type,
                      // url: `${baseURL}`+ file.url
                      url: file.url
                    }))
                  })
                } else {
                  this.messages.push({
                    content: item.query,
                    isUser: true
                  });
                }
              }
              if (item.answer) {
                this.messages.push({
                  content: this.formatMessage(item.answer),
                  isUser: false,
                  responseTime: this.getCurrentTime(item.created_at),
                  message_id: item.id,
                  rating: item.feedback?.rating || null
                });
              }
            });
            // this.scrollToBottom();
            this.forceScrollToBottom()
          }
        })
        .catch((error) => {
          this.$message.error(error || this.$t("chatPage.getHistoryMessageError"));
        });
    },

    //格式化时间
    getCurrentTime(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取AI助手下一轮问题建议列表
    loadSuggestedList() {
      suggestedList(this.message_id, {
        access_type: this.accessType,
        user: this.userInfo.user_id
      }).then(res => {
        if (res.data) {
          this.suggestList = res.data.data.data;
        }
      }).catch(err => {
        console.log("获取下一轮问题建议列表失败", err);
      })
    },

    // 点击问题建议
    handleClick(item) {
      this.newMessage = item;
      this.sendMessage();
    },

    //滚动到底部
    // scrollToBottom() {
    //   this.$nextTick(() => {
    //     const container = this.$refs.messagesContainer;
    //     if (container?.scrollHeight && this.isAtBottom) {
    //       this.$nextTick(() => {
    //         container.scrollTop = container.scrollHeight;
    //       });
    //     }
    //   });
    // },

    // 强制滚动到底（用于加载历史、初始化等场景）
    forceScrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
          // 可选：强制标记为在底部
          this.isAtBottom = true;
        }
      });
    },

    // 智能滚动（仅当用户在底部时才滚）
    smartScrollToBottom() {
      if (this.isAtBottom) {
        this.forceScrollToBottom();
      }
    },

    //滚动到底部按钮
    btnClickScrollToBottom() {
      const container = this.$refs.messagesContainer;
      if (container) {
        this.showScrollToBottom = false;
        this.isScrollingToBottom = true;
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        });
      }
    },

    //新对话
    startNewChat() {
      this.isReadonly = this.tempReadonly
      let content = "";
      if (this.accessType === "tz") {
        if (this.userInfo) {
          content = this.userInfo.user_name + '，' + this.$t(config.chatContentConfig.aiContent);
        } else {
          content = this.$t(config.chatContentConfig.aiContent);
        }
      } else if (this.accessType === "tpc") {
        if (this.userInfo) {
          content = `<span style="color: #1a73e8; font-weight: 600;"> ${this.userInfo.user_name}, </span>&nbsp  ${this.$t(config.chatContentConfig.tpcContent)}`;
        } else {
          content = this.$t(config.chatContentConfig.tpcContent);
        }
      } else if (this.accessType === "tzj") {
        if (this.userInfo) {
          content = `<span style="color: #1a73e8; font-weight: 600;"> ${this.userInfo.user_name}, </span>&nbsp  ${this.$t(config.chatContentConfig.tzjContent)}`;
        } else {
          content = this.$t(config.chatContentConfig.tzjContent);
        }
      }
      this.requestData.access_type = this.accessType;
      if (this.accessType === "tz") {
        this.showChatPreview = false;
      } else {
        this.showChatPreview = true;
        this.$root.$emit('preview-success-Close'); // 👈 通知 preview
        // 暂时隐藏：switchBool 和 switchDrawer 在 ChatPreview.vue 中未定义
        // if(this.$refs.chatPreview?.$data.switchBool){
        //   this.$refs.chatPreview?.switchDrawer(true);
        // }
      }
      this.handleLayoutChange();
      this.messages = [
        {
          content: content,
          isUser: false,
          isTyping: false,
          isWelcome: true   // ← 必须加这一行！

        },
      ];
      this.suggestList = [];
      this.conversationId = ""; // 置空 conversationId
      // 重置滚动按钮状态
      this.showScrollToBottom = false;
      this.isScrollingToTop = false;
      this.isScrollingToBottom = false;
      // logs清空日志
      this.analyItems = [];
      this.showLog = false;
      const currentUrl = window.location.href;
      const index = currentUrl.indexOf('?');
      let newUrl = "";
      if (index !== -1) {
        newUrl = currentUrl.slice(0, index);
      } else {
        newUrl = currentUrl;
      }
      window.history.pushState({}, '', newUrl);
      this.currentChatIndex = -1;
      this.$refs.chatPreview?.clearInfo(); // 重置 chatPreview 组件的数据
      this.chatHistory.unshift({
        preview: this.$t("chatPage.newChat"),
        time: this.getCurrentTime(),
        messages: [...this.messages],
      });
      this.currentChatIndex = 0;
    },

    //切换对话
    switchChat(index) {
      // logs清空日志
      this.analyItems = [];
      this.showLog = false;
      
      this.currentChatIndex = index;
      this.messages = [...this.chatHistory[index].messages];
      this.isAtBottom = true;
      // this.scrollToBottom();
      this.forceScrollToBottom()
    },

    //更新预览
    updateChatPreview(message) {
      if (this.currentChatIndex === -1) {
        this.startNewChat();
      }

      const preview =
        message.length > 20 ? message.substring(0, 20) + "..." : message;
      this.chatHistory[this.currentChatIndex].preview = preview;
      this.chatHistory[this.currentChatIndex].time = this.getCurrentTime();
      this.chatHistory[this.currentChatIndex].messages = [...this.messages];
    },

    // 格式化消息内容
    formatMessage(text) {
      if (!text) return "";

      // 自定义链接渲染规则
      md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const token = tokens[idx];
        const hrefIndex = token.attrIndex("href");
        if (hrefIndex >= 0) {
          const href = token.attrs[hrefIndex][1];
          const hasTarget = this.checkUrlContainsPath(href, 'ai_open_file');
          if (hasTarget) {
            //假设fileId是会话id，用于后期传参
            const fileId = href.split('/').pop();
            // const buttonHtml = `<button class="excel-view-btn" data-file-id="${fileId}" onclick="window.openExcelViewer('${fileId}')">${tokens[idx + 1].content}</button>`;
            const buttonHtml = `<span class="span-link" data-file-id="${fileId}" onclick="window.openExcelViewer('${fileId}')">${tokens[idx + 1].content}</span>`;

            // 2. 标记当前链接为特殊链接
            token.attrSet('is-special-link', 'true');

            // 3. 清空后续文本token内容（原始URL）
            if (tokens[idx + 1] && tokens[idx + 1].type === 'text') {
              tokens[idx + 1].content = ''; // 关键：清除URL文本
            }

            return buttonHtml;
          } else {
            token.attrSet("target", "_blank");
            token.attrSet("rel", "noopener noreferrer");
          }
        }
        return self.renderToken(tokens, idx, options);
      };

      md.renderer.rules.link_close = (tokens, idx, options, env, self) => {
        // 获取对应打开标签token（link_close在link_open后2个位置）
        const linkOpenToken = tokens[idx - 2];
        if (linkOpenToken && linkOpenToken.attrGet('is-special-link') === 'true') {
          return ''; // 特殊链接不渲染闭合标签
        }
        return self.renderToken(tokens, idx, options); // 普通链接正常渲染
      };

      // md.renderer.rules.text = (tokens, idx, options, env, self) => {
      //   const token = tokens[idx];

      //   // 仅处理父级为有效数字索引的文本节点
      //   if (typeof token.parent === 'number') {
      //     const parentToken = tokens[token.parent];
      //     // 检查父级是否为特殊链接
      //     if (parentToken?.type === 'link_open' && parentToken.attrGet('is-excel-link') === 'true') {
      //       return ''; // 隐藏原始URL文本
      //     }
      //   }
      //   // 普通文本正常渲染
      //   return self.renderToken(tokens, idx, options);
      // };

      // 自定义数学公式渲染规则
      const renderMath = (content, displayMode) => {
        try {
          return katex.renderToString(content, { displayMode });
        } catch (error) {
          return displayMode ? `$$${content}$$` : `$${content}$`;
        }
      };

      // 自定义数学公式渲染规则-行内公式
      md.renderer.rules.math_inline = function (tokens, idx) {
        const content = tokens[idx].content;
        try {
          return katex.renderToString(content, { displayMode: false });
        } catch (error) {
          return `$${content}$`;
        }
      };

      // 自定义数学公式渲染规则-块级
      md.renderer.rules.math_block = function (tokens, idx) {
        const content = tokens[idx].content;
        try {
          return katex.renderToString(content, { displayMode: true });
        } catch (error) {
          return `$$${content}$$`;
        }
      };

      // 渲染数学公式
      text = text.replace(/\\\[/g, "$$").replace(/\\\]/g, "$$"); // 替换 \[ 和 \] 为 $$
      text = text.replace(/\\\(/g, '$').replace(/\\\)/g, '$') // 替换 \( 和 \) 为 $
      text = text
        .replace(/\$\$([\s\S]*?)\$\$/g, (_, formula) =>
          renderMath(formula, true)
        )
        .replace(/\$([^$]*?)\$/g, (_, formula) => renderMath(formula, false));

      // 如果\n后面紧跟数字, 转换为 \n 1
      text = text.replace(/\n(\d+)/g, "\n $1 ");

      // 渲染 ECharts 图表
      text = text.replace(/```echarts([\s\S]*?)```/g, (_, option) => {
        const containerId = `echarts-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        setTimeout(() => {
          const container = document.getElementById(containerId);
          console.log("是否获取到container", container)
          if (container) {
            const chart = echarts.init(container);

            // 设置ECharts配置
            const chartOption = JSON.parse(option);
            chart.setOption(chartOption);

            // 创建防抖的resize函数
            const debouncedResize = debounce(() => {
              if (chart && !chart.isDisposed()) {
                chart.resize();
              }
            }, 100);

            // 监听容器大小变化
            const resizeObserver = new ResizeObserver(() => {
              debouncedResize();
            });
            resizeObserver.observe(container);

            // 监听窗口大小变化
            window.addEventListener('resize', debouncedResize);

            // 存储清理函数，用于后续清理
            container._echartsCleanup = () => {
              resizeObserver.disconnect();
              window.removeEventListener('resize', debouncedResize);
              if (chart && !chart.isDisposed()) {
                chart.dispose();
              }
            };
          }
        });
        return `<div id="${containerId}" class="echarts-container"></div>`;
      }, 100);

      return md.render(text);
    },

    // 检查URL是否包含指定路径
    checkUrlContainsPath(url, targetPath) {
      if (!url) return false;
      try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        const pathSegments = pathname.split('/').filter(segment => segment.trim() !== '');
        return pathSegments.includes(targetPath);
      } catch (err) {
        console.error('URL解析错误:', err);
        return false;
      }
    },

    // 上传文件
    async handleAddFile() {
      if (this.requestData.files.length > 20) {
        this.$message({
          message: this.$t("chatPage.maxFileCount"),
          type: "warning",
        });
        return;
      }
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = this.fileAccept;
      fileInput.multiple = true;
      fileInput.onchange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length + this.requestData.files.length > 20) {
          this.$message({
            message: this.$t("chatPage.maxFileCount"),
            type: "warning",
          });
          return;
        }
        // 设置上传状态和初始化进度
        this.uploading = true;
        this.uploadingFiles = [...files];
        this.uploadProgress = {}; // 重置进度
        const validExtensions = this.fileAccept.split(',').map(ext => ext.trim().toLowerCase());
        for (const file of files) {
          // 为每个文件初始化进度为0
          this.$set(this.uploadProgress, file.name, 0);
          const fileName = file.name.toLowerCase();
          const isValid = validExtensions.some(ext => fileName.endsWith(ext));

          if (!isValid) {
            this.$message({
              message: this.$t('chatPage.invalidFormat', {
                filename: file.name,
                formats: this.fileAccept
              }),
              type: "warning",
            });
            // 从上传列表中移除无效文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            delete this.uploadProgress[file.name];
            continue;
          }
          if (file.size > 100 * 1024 * 1024) {
            this.$message({
              message: this.$t('chatPage.maxFileSize', {
                filename: file.name,
                formats: "100MB"
              }),
              type: "warning",
            });
            // 从上传列表中移除过大文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            delete this.uploadProgress[file.name];
            continue;
          }
          const formData = new FormData();
          formData.append("file", file);
          formData.append("user", this.requestData.user);
          formData.append("type", fileInput.accept);
          formData.append("access_type", this.accessType);
          this.newMessage = this.$t("chatPage.messageFile");

          try {
            // 使用原生axios请求支持进度跟踪
            const response = await request({
              method: 'post',
              url: '/pack/uploadFile',
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable) {
                  const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                  // 更新当前文件的上传进度
                  this.$set(this.uploadProgress, file.name, progress);
                }
              }
            });

            const fileUrl = URL.createObjectURL(file);
            this.requestData.files.push({
              name: response.data.data.name || file.name,
              type: "document",
              size: (file.size / 1024).toFixed(2) + " KB",
              url: fileUrl,
              upload_file_id: response.data.data.id,
              transfer_method: "local_file",
            });
            // 上传完成后移除进度信息
            delete this.uploadProgress[file.name];
            // 从上传列表中移除已完成的文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            // 如果所有文件都上传完成，更新上传状态
            if (this.uploadingFiles.length === 0) {
              this.uploading = false;
            }
          } catch (error) {
            this.$message({
              message: this.$t('chatPage.fileUploadError', {
                filename: file.name,
              }),
              type: "error",
            });
            // 上传失败后移除进度信息
            delete this.uploadProgress[file.name];
            // 从上传列表中移除失败的文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            // 如果所有文件都处理完成，更新上传状态
            if (this.uploadingFiles.length === 0) {
              this.uploading = false;
            }
          }
        }
      };
      fileInput.click();
    },

    // 上传图片
    async handleAddImage() {
      if (this.requestData.files.length > 20) {
        this.$message({
          message: this.$t("chatPage.maxFileCount"),
          type: "warning",
        });
        return;
      }
      const imageInput = document.createElement("input");
      imageInput.type = "file";
      imageInput.accept = this.imageAccept; // 限制为 png、jpg 和 jpeg 格式
      imageInput.multiple = true; // 支持多图片选择
      imageInput.onchange = async (event) => {
        const images = Array.from(event.target.files);
        if (images.length + this.requestData.files.length > 20) {
          this.$message({
            message: this.$t("chatPage.maxFileCount"),
            type: "warning",
          });
          return;
        }
        // 设置上传状态
        this.uploading = true;
        this.uploadingFiles = [...images];
        for (const image of images) {
          const validFormats = ["image/png", "image/jpeg"];
          if (!validFormats.includes(image.type)) {
            this.$message({
              // message: `图片 ${image.name} 仅支持上传 png、jpg 或 jpeg 格式`,
              message: this.$t('chatPage.invalidFormat', {
                filename: image.name,
                formats: this.imageAccept
              }),
              type: "warning",
            });
            continue;
          }
          if (image.size > 100 * 1024 * 1024) {
            // 限制大小为 100MB
            this.$message({
              // message: `图片 ${image.name} 大小不能超过100MB，请重试`,
              message: this.$t('chatPage.maxFileSize', {
                filename: image.name,
                formats: "100MB"
              }),
              type: "warning",
            });
            continue;
          }
          const formData = new FormData();
          formData.append("file", image);
          formData.append("user", this.requestData.user);
          formData.append("type", imageInput.accept);
          formData.append("access_type", this.accessType);
          this.newMessage = this.$t("chatPage.messageFile");
          try {
            const response = await uploadFile(formData); // 调用封装的 upload 方法
            const imageUrl = URL.createObjectURL(image);
            this.requestData.files.push({
              name: response.data.data.name || image.name,
              type: "image",
              size: (image.size / 1024).toFixed(2) + " KB",
              url: imageUrl,
              upload_file_id: response.data.data.id,
              transfer_method: "local_file",
            });
            // 从上传列表中移除已完成的文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== image);

            // 如果所有文件都上传完成，更新上传状态
            if (this.uploadingFiles.length === 0) {
              this.uploading = false;
            }
          } catch (error) {
            this.$message({
              // message: `图片 ${image.name} 上传失败，请重试`,
              message: this.$t('chatPage.fileUploadError', {
                filename: image.name,
              }),
              type: "error",
            });
            // 从上传列表中移除失败的文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== image);

            // 如果所有文件都处理完成，更新上传状态
            if (this.uploadingFiles.length === 0) {
              this.uploading = false;
            }
          }
        }
      };
      imageInput.click();
    },

    // 统一上传文件
    async handleUnifiedUpload() {
      if (this.requestData.files.length > 20) {
        this.$message({
          message: this.$t("chatPage.maxFileCount"),
          type: "warning",
        });
        return;
      }

      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = `${this.fileAccept},${this.imageAccept}`; // 同时支持文档和图片
      fileInput.multiple = true;

      fileInput.onchange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length + this.requestData.files.length > 20) {
          this.$message({
            message: this.$t("chatPage.maxFileCount"),
            type: "warning",
          });
          return;
        }

        // 设置上传状态和初始化进度
        this.uploading = true;
        this.uploadingFiles = [...files];
        this.uploadProgress = {}; // 重置进度

        // 定义支持的图片格式
        const imageFormats = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp'];

        for (const file of files) {
          // 为每个文件初始化进度为0
          this.$set(this.uploadProgress, file.name, 0);

          // 根据文件扩展名判断文件类型
          const fileName = file.name.toLowerCase();
          const fileExt = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
          const isImage = imageFormats.includes(fileExt);
          const fileType = isImage ? 'image' : 'document';

          // 获取对应的接受类型进行验证
          const acceptType = isImage ? this.imageAccept : this.fileAccept;
          const validExtensions = acceptType.split(',').map(ext => ext.trim().toLowerCase());

          // 文件格式验证
          const isValid = validExtensions.some(ext => fileName.endsWith(ext));

          if (!isValid) {
            this.$message({
              message: this.$t('chatPage.invalidFormat', {
                filename: file.name,
                formats: acceptType
              }),
              type: "warning",
            });
            // 从上传列表中移除无效文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            delete this.uploadProgress[file.name];
            continue;
          }

          // 文件大小验证
          if (file.size > 100 * 1024 * 1024) {
            this.$message({
              message: this.$t('chatPage.maxFileSize', {
                filename: file.name,
                formats: "100MB"
              }),
              type: "warning",
            });
            // 从上传列表中移除过大文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            delete this.uploadProgress[file.name];
            continue;
          }

          const formData = new FormData();
          formData.append("file", file);
          formData.append("user", this.requestData.user);
          formData.append("type", fileInput.accept);
          formData.append("access_type", this.accessType);
          this.newMessage = this.$t("chatPage.messageFile");

          try {
            // 使用统一的请求方法
            const response = await request({
              method: 'post',
              url: '/pack/uploadFile',
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable) {
                  const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                  // 更新当前文件的上传进度
                  this.$set(this.uploadProgress, file.name, progress);
                }
              }
            });

            const fileUrl = URL.createObjectURL(file);
            this.requestData.files.push({
              name: response.data.data.name || file.name,
              type: fileType, // 动态设置文件类型
              size: (file.size / 1024).toFixed(2) + " KB",
              url: fileUrl,
              upload_file_id: response.data.data.id,
              transfer_method: "local_file",
            });

            // 上传完成后移除进度信息
            delete this.uploadProgress[file.name];
            // 从上传列表中移除已完成的文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            // 如果所有文件都上传完成，更新上传状态
            if (this.uploadingFiles.length === 0) {
              this.uploading = false;
            }
          } catch (error) {
            this.$message({
              message: this.$t('chatPage.fileUploadError', {
                filename: file.name,
              }),
              type: "error",
            });
            // 上传失败后移除进度信息
            delete this.uploadProgress[file.name];
            // 从上传列表中移除失败的文件
            this.uploadingFiles = this.uploadingFiles.filter(f => f !== file);
            // 如果所有文件都处理完成，更新上传状态
            if (this.uploadingFiles.length === 0) {
              this.uploading = false;
            }
          }
        }
      };

      fileInput.click();
    },

    // 停止响应
    stopResponse() {
      if (!this.task_id) return;
      if (this.accessType != "tz") {
        // this.$refs.chatPreview.stopResponse(); //暂时禁用
        this.reStart = true;
      }
      stopChat({
        task_id: this.task_id,
        access_type: this.accessType,
        user: this.userInfo.user_id,
      })
        .then((res) => {
          console.log("stopChat", res);
        })
        .catch((error) => {
          console.log("stopChat error", error);
        });
      this.$store.commit("setIsResponding", false);
      this.isResponding = false;
      this.messages[this.messages.length - 1].isLoading = false;
    },

    updateReStart(val) {
      this.reStart = val;
    },

    updateShowPreview(val) {
      this.showPreview = val;
    },

    // 删除文件
    removeFile(index) {
      this.requestData.files.splice(index, 1); // 删除指定文件
      if (this.requestData.files.length === 0) {
        this.newMessage = ""; // 如果没有文件，清空输入框
      }
    },

    //复制消息
    copyText(v) {
      const text = v.replace(/<[^>]*>/g, '');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message({
            message: this.$t('ChooseProduct.copySuccess'),
            type: 'success'
          });
        }).catch(() => {
          this.fallbackCopyTextToClipboard(text);
        });
      } else {
        this.fallbackCopyTextToClipboard(text);
      }
    },
    fallbackCopyTextToClipboard(text) {
      const cleanText = text.replace(/<[^>]*>/g, '');
      const textarea = document.createElement('textarea');
      textarea.value = cleanText;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message({
            message: this.$t('ChooseProduct.copySuccess'),
            type: 'success'
          });
        } else {
          this.$message({
            message: this.$t('ChooseProduct.copyFail'),
            type: 'error'
          });
        }
      } catch (err) {
        this.$message({
          message: this.$t('ChooseProduct.copyFail'),
          type: 'error'
        });
      }
      document.body.removeChild(textarea);
    },

    // 点赞/点踩
    handleReaction(message, index, type) {
      if (type === 'like') {
        // 点赞
        const newRating = message.rating === 'like' ? null : 'like';
        this.sendFeedback(message, index, newRating);
      } else if (type === 'dislike') {
        // 点踩
        if (message.rating === 'dislike') {
          // 取消点踩
          this.sendFeedback(message, index, null);
        } else {
          this.feedBackVisible = true;
          this.tempRating = 'dislike';
          this.tempMessageIndex = index;
        }
      }
    },

    // 选择反馈
    selectFeedBack(item) {
      this.selectedFeedBack = item;
    },

    // 提交反馈
    handleFeedback(message, index) {
      // 处理点踩后的反馈提交
      if (this.tempRating) {
        this.sendFeedback(message, index, this.tempRating);
        this.tempRating = null;
        this.tempMessageIndex = null;
      }
      this.feedBackVisible = false;
    },

    //反馈接口
    sendFeedback(message, index, newRating) {
      let feedContent = ""
      if (message.feedback) {
        feedContent = message.feedback;
      } else if (this.selectedFeedBack) {
        feedContent = this.selectedFeedBack;
      } else {
        feedContent = ""
      }
      const feedbackInfo = {
        user: this.userInfo.user_id,
        rating: newRating,
        content: feedContent,
        access_type: "tz",
      };
      this.selectedFeedBack = "";
      sendFeedbackApi(message.message_id, feedbackInfo).then((res) => {
        if (res.data.data.result === "success") {
          message.rating = newRating;
          this.$set(this.messages, index, message);
          this.feedBackVisible = false;
        }
      }).catch((error) => {
        console.log(error);
      });
    },

    // 接收子组件回调
    async saveAndSendFile(file) {
      if (file.size > 100 * 1024 * 1024) {
        // 限制大小
        this.$message({
          // message: `文件 ${file.name} 大小不能超过100MB，请重试`,
          message: this.$t('chatPage.maxFileSize', {
            filename: file.name,
            formats: "100MB"
          }),
          type: "warning",
        });
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("user", this.requestData.user);
      formData.append("type", this.fileAccept);
      formData.append("access_type", this.accessType);
      this.newMessage = this.$t("chatPage.messageFile");
      try {
        const response = await uploadFile(formData); // 调用封装的 upload 方法
        const fileUrl = URL.createObjectURL(file); // 生成本地文件的下载链接
        this.requestData.files.push({
          name: response.data.data.name || file.name,
          type: "document",
          size: (file.size / 1024).toFixed(2) + " KB",
          url: fileUrl, // 使用本地文件链接
          upload_file_id: response.data.data.id,
          transfer_method: "local_file",
        });
        this.$refs.excelViewer?.saveDraft(); // 隐藏 ExcelViewer 模态框
        this.sendMessage(); // 发送消息
      } catch (error) {
        this.$message({
          // message: `附件 ${file.name} 上传失败，请重试`,
          message: this.$t('chatPage.fileUploadError', {
            filename: file.name,
          }),
          type: "error",
        });
      }
    },

    // 处理布局变化
    handleLayoutChange() {
      // console.log('视口变化，重新计算布局...');

      this.$nextTick(() => {
        const sidebarElement = document.querySelector('.sidebar');
        const chatPreviewElement = document.querySelector('.chat-preview');
        const chatContainer = document.querySelector('.chat-container');
        const sidebarWidth = sidebarElement?.offsetWidth || 357;
        const chatPreviewWidth = chatPreviewElement?.offsetWidth || 92;

        // 获取当前视口信息
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const devicePixelRatio = window.devicePixelRatio || 1;

        // console.log(`视口信息: ${viewportWidth}x${viewportHeight}, 像素比: ${devicePixelRatio}`);

        if (this.accessType === 'tz') {
          chatContainer.style.width = `${Math.max(viewportWidth - sidebarWidth - 12)}px`;
          chatContainer.style.marginLeft = `${Math.max(sidebarWidth)}px`;
          chatContainer.style.marginRight = '0px';
        } else if (this.accessType === 'tpc' || this.accessType === 'tzj') {
          if (sidebarElement && chatPreviewElement) {
            // 动态计算chat-container的可用宽度
            const availableWidth = viewportWidth - sidebarWidth - chatPreviewWidth - 22; // 减去边距
            // 更新chat-container的样式
            if (chatContainer) {
              chatContainer.style.width = `${Math.max(availableWidth)}px`;
              chatContainer.style.marginLeft = `${Math.max(sidebarWidth)}px`;
              chatContainer.style.marginRight = `${Math.max(chatPreviewWidth + 22)}px`;
            }
          }
        }

        // 新增：处理移动端适配
        this.handleMobileLayout(viewportWidth);

        // 新增：处理高DPI屏幕适配
        this.handleHighDPILayout(devicePixelRatio);
      });
    },

    // 新增：处理移动端布局
    handleMobileLayout(viewportWidth) {
      if (viewportWidth <= 768) {
        // 移动端布局调整
        const chatContainer = document.querySelector('.chat-container');
        if (chatContainer) {
          chatContainer.style.minWidth = '100%';
          chatContainer.style.maxWidth = '100%';
        }
      } else {
        // 桌面端布局恢复
        const chatContainer = document.querySelector('.chat-container');
        if (chatContainer) {
          chatContainer.style.minWidth = '';
          chatContainer.style.maxWidth = '';
        }
      }
    },

    // 新增：处理高DPI屏幕适配
    handleHighDPILayout(devicePixelRatio) {
      if (devicePixelRatio > 1) {
        // 高DPI屏幕优化
        const elements = document.querySelectorAll('.message-content, .input-area');
        elements.forEach(element => {
          element.style.webkitFontSmoothing = 'antialiased';
          element.style.mozOsxFontSmoothing = 'grayscale';
        });
      }
    },

    // 日志的播放逻辑
    startScroll() {
      this.clearTimer();

      // 如果已经播到最后，就不启动
      if (this.analyItems.length === 0 || this.currentIndex >= this.analyItems.length - 1) {
        return;
      }

      this.scrollTimer = setInterval(() => {
        if (this.currentIndex < this.analyItems.length - 1) {
          this.currentIndex++;
        } else {
          this.clearTimer(); // 播完停止
        }
      }, 500); // 👈 改为 0.5 秒
    },

    // 销毁日志滚动
    clearTimer() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },

    // logs 处理新日志
    handleNewLogs(logLines) {
      if (!logLines || !Array.isArray(logLines) || logLines.length === 0) {
        return;
      }

      const texts = logLines.map(line => line.item || line);
      this.analyItems.push(...texts);
      console.log(this.analyItems,'this.analyItems')
      this.showLog = true;
      this.showAnalysisImg = true
      this.startScroll();
    },

    // 日志滚动到底部的函数
    analysisScrollToBottom() {
      const el = this.$refs.analysisContent;
      if (el) {
        el.scrollTop = el.scrollHeight; // 强制滚到底
      }
    },

    // 日志的展开和关闭
    toggleAnalysis() {
      if (this.analyItems.length == 0) {
        return
      }
      console.log(this.analyItems,'this.analyItems')
      this.showAnalysis = !this.showAnalysis;
    }
  },
  // 日志销毁之前
  beforeUnmount() {
    this.clearTimer();
  },
  // 组件挂载后执行
  mounted() {
    this.isReadonly = this.tempReadonly
    const message = this.$store.state.message; // 从 Vuex 获取输入内容

    if (message) {
      this.newMessage = message;
      this.sendMessage();
      this.$store.commit("setMessage", ""); // 清空 Vuex 中的内容
    }
    // 接收 query 信息
    const queryId = this.$route.query.id;
    if (queryId) {
      this.conversationId = queryId;
      // this.isHistory = true;
      this.reStart = true;
      this.$nextTick(() => {
        this.$refs.chatPreview?.clearInfo();
        // this.$refs.chatPreview?.getContent({ isHistory: true, id: queryId }); //暂时禁用
        // this.$refs.chatPreview?.switchDrawer(true); //暂时禁用
        // 从历史记录进入时，启动右边屏 SSE
        if (this.accessType != 'tz' && this.$refs.chatPreview) {
          this.$refs.chatPreview.startSideScreenSSE();
        }
      });
      this.getHistoryMessages();
      this.$router.replace({ name: "ChatPage", query: { id: queryId } }).catch(err => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    }

    // 添加滚动事件监听器
    this.$nextTick(() => {
      const container = this.$refs.messagesContainer;
      if (container) {
        const handleScroll = () => {
          // 计算用户是否在底部（允许一定的容差）
          const tolerance = 250; // 容差值，用户距离底部小于这个值时视为在底部
          this.isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight <= tolerance;
          // 判断是否显示上滑按钮（当不在顶部时显示）
          // 如果正在滚动到顶部，不更新按钮显示状态
          if (!this.isScrollingToTop) {
          } else {
            // 如果已经滚动到顶部附近，重置标志
            if (container.scrollTop <= 100) {
              this.isScrollingToTop = false;
            }
          }
          // 判断是否显示下滑按钮（当不在底部时显示）
          if (!this.isScrollingToBottom) {
            this.showScrollToBottom = container.scrollTop < container.scrollHeight - container.clientHeight - 100;
          } else {
            // 如果已经滚动到底部附近，重置标志
            if (container.scrollTop >= container.scrollHeight - container.clientHeight - 100) {
              this.isScrollingToBottom = false;
              this.showScrollToBottom = false;
            }
          }
        }
        container.addEventListener('scroll', handleScroll);
        // 组件销毁时移除事件监听器
        this.$once('hook:beforeDestroy', () => {
          container.removeEventListener('scroll', handleScroll);
        });
      }
    });

    // 新增：监听窗口大小变化
    this.windowResizeHandler = () => {
      this.debouncedHandleLayoutChange();
    };
    window.addEventListener('resize', this.windowResizeHandler);

    // 新增：监听视口变化（使用 ResizeObserver）
    if (window.ResizeObserver) {
      this.viewportObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === document.documentElement || entry.target === document.body) {
            this.debouncedHandleLayoutChange();
          }
        }
      });

      // 监听文档根元素和body元素的变化
      if (document.documentElement) {
        this.viewportObserver.observe(document.documentElement);
      }
      if (document.body) {
        this.viewportObserver.observe(document.body);
      }
    }

    // 新增：监听页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  created() {
    this.isReadonly = this.tempReadonly
    // 初始化一个新对话
    this.startNewChat();
    this.requestData.access_type = this.accessType;
    if (this.accessType == "tz") {
      this.showChatPreview = false;
    } else {
      this.showChatPreview = true;
    }
    this.debouncedShowTime = debounce((index) => {
      this.showTimeIndex = index;
    }, 100);

    // 新增：创建防抖的布局变化处理函数
    this.debouncedHandleLayoutChange = debounce(() => {
      this.handleLayoutChange();
    }, 150);
    const self = this;
    window.openExcelViewer = function (fileId) {
      if (self.$refs.excelViewer) {
        // 传递文件ID给ExcelViewer组件
        self.$refs.excelViewer.showModal(fileId);
      }
    };
  },
  watch: {
    // 日志的滚动
    currentIndex() {
      if (this.showAnalysis) {
        this.$nextTick(() => {
          const el = this.$refs.analysisContent;
          if (el) {
            el.scrollTop = el.scrollHeight; // 滚到底
          }
        });
      }
    },
    sidebarExpanded: {
      handler(newVal) {
        this.handleLayoutChange();
      },
      immediate: true
    },
    previewExpanded: {
      handler(newVal) {
        this.handleLayoutChange();
      },
      immediate: true
    },
    isResponding(newVal) {
      this.$store.commit("setIsResponding", newVal); // 将状态同步到 Vuex
    },
    "$route.query.id": {

      immediate: true,
      handler(newId) {
        if (newId) {
          this.isReadonly = this.tempReadonly

          this.conversationId = newId;
          this.handleLayoutChange();
          this.requestData.access_type = this.accessType;
          // this.isHistory = true;
          this.reStart = true;
          // this.$refs.chatPreview?.stopResponse(); //暂时禁用
          this.$refs.chatPreview?.clearInfo();
          // this.$refs.chatPreview?.getContent({ isHistory: true, id: newId }); //暂时禁用
          // this.$refs.chatPreview?.switchDrawer(true); //暂时禁用
          this.getHistoryMessages();
          // 从历史记录进入时，启动右边屏 SSE
          this.$nextTick(() => {
            if (this.accessType != 'tz' && this.$refs.chatPreview) {
              this.$refs.chatPreview.startSideScreenSSE();
            }
          });
        }
      },
    },
    '$i18n.locale'(newLocale) {
      // 监听语言变化并更新请求参数
      this.requestData.inputs.language = newLocale;
    }
  },
  beforeDestroy() {
    // 在组件销毁前关闭
    this.isResponding = false;
    this.debouncedShowTime.cancel(); // 组件销毁时取消防抖函数

    // 新增：清理视口监听器
    if (this.windowResizeHandler) {
      window.removeEventListener('resize', this.windowResizeHandler);
    }

    if (this.viewportObserver) {
      this.viewportObserver.disconnect();
    }

    document.removeEventListener('visibilitychange', this.handleVisibilityChange);

    if (this.debouncedHandleLayoutChange) {
      this.debouncedHandleLayoutChange.cancel();
    }

    // 清理所有ECharts实例和监听器
    const echartsContainers = document.querySelectorAll('.echarts-container');
    echartsContainers.forEach(container => {
      if (container._echartsCleanup) {
        container._echartsCleanup();
      }
    });
  },
}
</script>

<style scoped>
@import "../assets/styles/index.css";

/* 样式代码保持不变 */
::v-deep .el-textarea__inner::placeholder {
  color: var(--global-placeholder);
  font-size: 16px;
  resize: none;
}

/* 谷歌 */
::v-deep .el-textarea__inner::-webkit-input-placeholder {
  color: var(--global-placeholder);
  font-size: 16px;
  resize: none;
}

/* 火狐 */
::v-deep .el-textarea__inner:-moz-placeholder {
  color: var(--global-placeholder);
  font-size: 16px;
  resize: none;
}

/*ie*/
::v-deep .el-textarea__inner:-ms-input-placeholder {
  color: var(--global-placeholder);
  font-size: 16px;
  resize: none;
}

::v-deep .excel-view-btn {
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 6px 12px;
  cursor: pointer;
  line-height: 120%;
  font-size: 16px;
  transition: background-color 0.2s;
  outline: none;
}

::v-deep .excel-view-btn:hover {
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
}

::v-deep .excel-view-btn:active {
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
}

::v-deep .span-link {
  color: #1a73e8;
  cursor: pointer;
  text-decoration: underline;
}

::v-deep .custom-dialog {
  margin-top: 0px !important;
  top: 50%;
  transform: translateY(-50%);
  width: 600px !important;
}

.custom-dialog {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.custom-dialog .el-dialog__header {
  /* background: linear-gradient(135deg, #56c697 0%, #339e9e 100%) !important; */
  background: var(--global-background);
  color: white !important;
  padding: 20px 24px 16px 24px !important;
  margin: 0 !important;
  border-bottom: none !important;
}

.custom-dialog .el-dialog__title {
  color: white !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.custom-dialog .el-dialog__headerbtn {
  top: 16px !important;
  right: 20px !important;
}

.custom-dialog .el-dialog__close {
  color: white !important;
  font-size: 20px !important;
}

.custom-dialog .el-dialog__close:hover {
  color: rgba(255, 255, 255, 0.8) !important;
}

.custom-dialog .el-dialog__body {
  padding: 24px !important;
  background: #fff !important;
}

.custom-dialog .el-dialog__footer {
  padding: 16px 24px 24px 24px !important;
  background: #fff !important;
  text-align: center !important;
}

.dialog-content {
  text-align: center;
}

.dialog-text {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.dialog-text_view {
  width: max-content;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
}

.dialog-text_view.active {
  border-color: #56c697;
  box-shadow: 0 2px 8px rgba(86, 198, 151, 0.3);
}

.custom-input {
  margin-top: 8px;
}

.custom-input .el-input__inner {
  border-radius: 8px !important;
  border: 2px solid #e4e7ed !important;
  padding: 12px 16px !important;
  font-size: 16px !important;
  transition: all 0.3s ease !important;
}

.custom-input .el-input__inner:focus {
  border-color: var(--global-primary) !important;
  box-shadow: 0 0 0 2px rgba(86, 198, 151, 0.2) !important;
}

.custom-input .el-input__count {
  color: #909399 !important;
  font-size: 12px !important;
}

.custom-cancel-btn {
  background: #f5f7fa !important;
  border: 1px solid #dcdfe6 !important;
  color: #606266 !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  margin-right: 16px !important;
  min-width: 80px !important;
  transition: all 0.3s ease !important;
}

.custom-cancel-btn:hover {
  background: #e6e8eb !important;
  border-color: #c0c4cc !important;
  color: #606266 !important;
}

.custom-confirm-btn {
  background: var(--global-primary) !important;
  border: none !important;
  color: white !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  min-width: 80px !important;
  box-shadow: 0 2px 8px rgba(86, 198, 151, 0.3) !important;
  transition: all 0.3s ease !important;
}

.custom-confirm-btn:hover {
  background: var(--global-primary) !important;
  box-shadow: 0 4px 12px rgba(86, 198, 151, 0.4) !important;
}

/* 删除确认框样式 */
.custom-delete-dialog {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.custom-delete-dialog .el-dialog__header {
  background: var(--global-background) !important;
  color: white !important;
  padding: 20px 24px 16px 24px !important;
  margin: 0 !important;
  border-bottom: none !important;
}

.custom-delete-dialog .el-dialog__title {
  color: white !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.custom-delete-dialog .el-dialog__headerbtn {
  top: 16px !important;
  right: 20px !important;
}

.custom-delete-dialog .el-dialog__close {
  color: white !important;
  font-size: 20px !important;
}

.custom-delete-dialog .el-dialog__close:hover {
  color: rgba(255, 255, 255, 0.8) !important;
}

.custom-delete-dialog .el-dialog__body {
  padding: 24px !important;
  background: #fff !important;
}

.custom-delete-dialog .el-dialog__footer {
  padding: 16px 24px 24px 24px !important;
  background: #fff !important;
  text-align: center !important;
}

.custom-delete-btn {
  background: var(--global-background) !important;
  border: none !important;
  color: white !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  min-width: 80px !important;
  box-shadow: 0 2px 8px rgba(86, 198, 151, 0.3) !important;
  transition: all 0.3s ease !important;
}

.custom-delete-btn:hover {
  background: var(--global-background) !important;
  box-shadow: 0 4px 12px rgba(86, 198, 151, 0.4) !important;
}

/* 上传进度显示样式 */
.upload-progress {
  flex: 1;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.file-name {
  font-size: 14px;
  color: #495057;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70%;
}

.progress-percent {
  font-size: 14px;
  color: #409EFF;
  font-weight: 600;
}

.progress-bar {
  margin-top: 4px;
}

/* Element UI进度条样式调整 */
::v-deep .progress-bar .el-progress-bar__outer {
  border-radius: 3px;
  background-color: #e9ecef;
}

::v-deep .progress-bar .el-progress-bar__inner {
  border-radius: 3px;
  transition: width 0.3s ease;
}

.other_view {
  padding: 6px;
}

/* 文件上传工具提示样式 */
:global(.file-tooltip) {
  white-space: pre-line;
  max-width: 400px;
}

/* logs 日志展示区域样式 */
.logs-container {
  margin-bottom: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  overflow: hidden;
  transition: all 0.3s ease;
}

.logs-header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #fff;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.logs-header:hover {
  background: #f5f7fa;
}

.logs-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-right: 6px;
}

.logs-count {
  font-size: 13px;
  color: #6c757d;
  margin-right: auto;
}

.logs-toggle-icon {
  font-size: 14px;
  color: #6c757d;
  transition: transform 0.3s ease;
}

.logs-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.logs-content.logs-expanded {
  max-height: 400px;
  overflow-y: auto;
}

.log-item {
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  border-bottom: 1px solid #e9ecef;
  font-size: 13px;
  line-height: 1.5;
  transition: background-color 0.2s;
}

.log-item:last-child {
  border-bottom: none;
}

.log-item:hover {
  background: #f0f2f5;
}

.log-time {
  color: #6c757d;
  font-size: 12px;
  margin-right: 12px;
  flex-shrink: 0;
  min-width: 60px;
}

.log-text {
  color: #495057;
  flex: 1;
  word-break: break-word;
}

/* 日志滚动条样式 */
.logs-content::-webkit-scrollbar {
  width: 6px;
}

.logs-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.logs-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.logs-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
